import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sources-container"
}

import SourceComponent from '@/components/LegalAssistant/SourceComponent.vue';
import { SourceDTO } from '@/dto/QuestionResponseDTO';
import { AssistantType } from '@/models/assistant-types';
import { useToasterStore } from '@/stores/useToasterStore';
import { useI18n } from 'vue-i18n';

interface Props {
  sources: SourceDTO[];
  assistantType: AssistantType;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MessageSources',
  props: {
    sources: {},
    assistantType: {}
  },
  setup(__props: any) {


const toaster = useToasterStore();
const { t } = useI18n();

function openDocument(url: string): void {
  if (url) window.open(url, '_blank');
  else
    toaster.error({
      title: t('message_sources.url.error_title'),
      body: t('message_sources.url.error_body')
    });
}

return (_ctx: any,_cache: any) => {
  return (_ctx.sources.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sources, (source, index) => {
          return (_openBlock(), _createBlock(SourceComponent, {
            key: index,
            title: 
        _ctx.assistantType === _unref(AssistantType).LegalAssistant
          ? source.title
          : source.doc_id
      ,
            description: source.section,
            clickable: true,
            onClick: () => openDocument(source.documentURL)
          }, null, 8, ["title", "description", "onClick"]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})